import { brandColors, notificationColors } from '../Components/Common/Color/Color'
import { SxProps } from '@mui/material'

export const iconButtonStyles: Record<string, SxProps> = {
  root: {
    borderRadius: 8, // Use a default border radius
    transition: 'background-color 0.3s, color 0.3s',

    // Error-specific styles
    '&.Mui-error': {
      color: notificationColors.red,
      '&:hover': {
        backgroundColor: notificationColors.redLight,
        color: notificationColors.redDark,
      },
      '&:disabled': {
        color: notificationColors.lightPink,
      },
    },
  },
  primary: {
    color: brandColors.purpleDeluge,
    '&:hover': {
      backgroundColor: brandColors.purpleDark,
      color: brandColors.purpleDark,
    },
    '&:disabled': {
      color: brandColors.purplePaleLavender,
    },
  },
  success: {
    color: brandColors.greenSanFelix,
    '&:hover': {
      backgroundColor: brandColors.greenAccessible,
      color: brandColors.greenAccessible,
    },
    '&:disabled': {
      color: brandColors.greenMutedGreen,
    },
  },
  warning: {
    color: notificationColors.amber,
    '&:hover': {
      backgroundColor: notificationColors.amberLight,
      color: notificationColors.amberDark,
    },
    '&:disabled': {
      color: notificationColors.disableAmber,
    },
  },
  default: {
    color: '#000',
    '&:hover': {
      backgroundColor: '#BDBDBD',
      color: '#333',
    },
    '&:disabled': {
      color: '#BDBDBD',
    },
  },
}
